import i18n from '../../plugins/i18n'
import { EQ, GT, GTE, IN, LT, LTE, NEQ, NIN } from '@/composables/filters/operators'
import {
  getAvailableProperties,
  getDataType,
  getOperators,
  getOptions,
  getOptionTitle,
  getPropertyTitle,
  getSortableProperties,
} from '@/composables/filters/filterHelpers'

const { t } = i18n.global

const properties = {
  state: {
    title: t('filters.indexed_documents.properties.state.title'),
    operators: [EQ, NEQ, IN, NIN],
    dataType: 'autocomplete',
    options: [
      { id: 'created', title: t('filters.indexed_documents.properties.state.options.created.title'), enabled: () => true },
      { id: 'source-available', title: t('filters.indexed_documents.properties.state.options.source-available.title'), enabled: () => true },
      { id: 'pending', title: t('filters.indexed_documents.properties.state.options.pending.title'), enabled: () => true },
      { id: 'failed', title: t('filters.indexed_documents.properties.state.options.failed.title'), enabled: () => true },
      { id: 'indexed', title: t('filters.indexed_documents.properties.state.options.indexed.title'), enabled: () => true },
      {
        id: 'marked-for-deletion',
        title: t('filters.indexed_documents.properties.state.options.marked-for-deletion.title'),
        enabled: () => true,
      },
      {
        id: 'marked-for-payload-update',
        title: t('filters.indexed_documents.properties.state.options.marked-for-payload-update.title'),
        enabled: () => true,
      },
      {
        id: 'needs-reindexing',
        title: t('filters.indexed_documents.properties.state.options.needs-reindexing.title'),
        enabled: () => true,
      },
    ],
  },
  globallyShared: {
    title: t('filters.indexed_documents.properties.globallyShared.title'),
    operators: [EQ, NEQ],
    dataType: 'boolean',
  },
  allowAPI: {
    title: t('filters.indexed_documents.properties.allowAPI.title'),
    operators: [EQ, NEQ],
    dataType: 'boolean',
  },
  allowWatchdog: {
    title: t('filters.indexed_documents.properties.allowWatchdog.title'),
    operators: [EQ, NEQ],
    dataType: 'boolean',
  },
  creationTimestamp: {
    title: t('filters.indexed_documents.properties.creationTimestamp.title'),
    operators: [EQ, NEQ, GT, GTE, LT, LTE],
    dataType: 'timestamp',
  },
}

const sortableProperties = ['creationTimestamp', 'lastEditedTimestamp', 'state']

export default {
  getOptionTitle: (propertyId, optionId) => getOptionTitle(properties, propertyId, optionId),
  getPropertyTitle: propertyId => getPropertyTitle(properties, propertyId),
  getAvailableProperties: () => getAvailableProperties(properties),
  getOperators: propertyId => getOperators(properties, propertyId),
  getDataType: propertyId => getDataType(properties, propertyId),
  getOptions: propertyId => getOptions(properties, propertyId),
  getSortableProperties: () => getSortableProperties(sortableProperties, properties),
}
